import { motion } from "framer-motion";
import { Asterisk } from "lucide-react";

const PHRASES = [
  "Parents & Caseworkers, Aligned",
  "Transparent Schedules",
  "Encrypted Communication",
  "Case-Ready Accuracy",
  "Tamper-Evident Records",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {PHRASES.map((p) => (
      <span key={p} className="flex items-center">
        <span className="font-serif italic text-2xl sm:text-3xl text-sage/70 whitespace-nowrap px-6">{p}</span>
        <Asterisk className="h-5 w-5 text-gold/70 shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="relative border-y border-ink/10 bg-paper-2 py-7 overflow-hidden" data-testid="editorial-marquee">
      <motion.div
        className="flex w-max"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 40, ease: "linear", repeat: Infinity }}
      >
        <Strip />
        <Strip />
      </motion.div>
    </div>
  );
}
